<template>
    <div id="statistics-tab" class="container">
        <div class="row head">
            <div class="period">
                <span>{{ getPeriod() }}</span>
            </div>

            <div @click="changePeriod(-1)" class="button button-center btn-period" :class="{'inactive':  period == 'day'}">
                <i class="iconify icon:mdi:chevron-left"></i>
            </div>

            <div @click="changePeriod(+1)" class="button button-center btn-period" :class="{'inactive':  overallStats}">
                <i class="iconify icon:mdi:chevron-right"></i>
            </div>

            <div class="country pull-right" @click="showCountrySelector = true">{{ countrySelected.name }}</div>
        </div>

        <div class="row tabs">
            <div v-for="(v, provider) in views" class="tab" @click="changeTab(provider)" :class="{'active' : activeTab == provider}">
                <div class="name" v-html="getName(provider)"></div>
                <div class="total"><animated-number :value="views[provider].show" :duration="500" :formatValue="formatToNumber"/></div>
                <div class="evolution">
                    <span class="yesterday"><animated-number :value="views[provider].yesterday" :duration="500" :formatValue="formatToNumber"/></span> / 
                    <span class="value" :class="{'text-green': views[provider].evolution > 0, 'text-red': views[provider].evolution < 0 && views[provider].evolution > -9999}"><animated-number :value="views[provider].evolution" :duration="500" :formatValue="formatToProcent"/></span>
                </div>

                <img :src="getIcon(provider)" alt=""/>
            </div> 
        </div>

        <div class="row items">
            <panel v-for="(v, provider) in views" :key="provider" :views="views" :period="period" :filter="filter" :user="user" :country="countrySelected" :overall-stats="overallStats" :media="provider" v-show="activeTab == provider" :selected="activeTab == provider"></panel>
        </div>

        <div class="move-to-root">
            <transition name="page-overlay">
                <div class="page-overlay country-selector" :id="oid" v-show="showCountrySelector">
                    <div class="container">
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="btn-close button button-center pull-left" @click="showCountrySelector = false">
                                    <i class="iconify" data-icon="ic:outline-chevron-left" data-inline="false"></i>
                                </div>
                            </div>

                            <div class="col-xs-12 content">
                                <input type="text" class="search-filters" placeholder="Search countries" v-model="search">
                                <i class="iconify" data-icon="ic:sharp-search"></i>

                                <h3>Select Country</h3>

                                <ul class="list countries">
                                    <li v-for="country in countries" class="button col-xs-4" @click="changeCountry(country)" :class="{'selected' : countrySelected.code == country.code, 'worldwide': !country.code }">{{ country.name }}</li>
                                </ul>
                            </div>

                            <div class="col-xs-12 text-center">
                                <div class="btn btn-default btn-outline button btn-back" @click="showCountrySelector = false">BACK</div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

    </div>
</template>

<script>
import AnimatedNumber from "animated-number-vue";  
export default {
    components: {
        AnimatedNumber,
        'chart-total': require('@/components/Song/Show/Tab/Statistics/Charts/Chart.vue').default,
        'panel': require('@/components/Profile/Tab/ProviderPanel.vue').default,
        'loader': require('@/components/Loader.vue').default,
    },

    props: ['user'],

    activated(){
        this.$nextTick(() => {
            var scrollLeft = $('#page-profile #statistics-tab .tabs .tab.active').position().left + $('#page-profile #statistics-tab .tabs').scrollLeft() - 30;
            $('#page-profile #statistics-tab .tabs').scrollLeft(scrollLeft);

            $('.item-container').scrollLeft(0);
            $('main').scrollTop(812 - $('main')[0].scrollHeight);
        });
    },

    data() {
        return {
            views: {
                total_streams: { total: -9999, partial: -9999, show: -9999, yesterday: -9999, evolution: -9999, evolution_type: null},
                youtube: { total: -9999, partial: -9999, show: -9999, yesterday: -9999, evolution: -9999, evolution_type: null},
                spotify_plays: { total: -9999, partial: -9999, show: -9999, yesterday: -9999, evolution: -9999, evolution_type: null},
                shazam: { total: -9999, partial: -9999, show: -9999, yesterday: -9999, evolution: -9999, evolution_type: null},
                warm_music: { total: -9999, partial: -9999, show: -9999, yesterday: -9999, evolution: -9999, evolution_type: null},
                soundcloud: { total: -9999, partial: -9999, show: -9999, yesterday: -9999, evolution: -9999, evolution_type: null},
                apple_music: { total: -9999, partial: -9999, show: -9999, yesterday: -9999, evolution: -9999, evolution_type: null},
            },

            events: false,
            activeTab: false,
            overallStats: false,
            oid: "country_selector_"+ Math.random().toString(36).substr(2, 9),

            countries: [{ name: 'Worldwide', code: 0 }],
            countrySelected: { name: 'Worldwide', code: 0 },
            showCountrySelector : false,
            search: '',

            filter: 'daily',
            period: 'week',

            validStates: {
                'day'   : {'daily': 1, 'weekly': 0, 'monthly': 0},
                'week'  : {'daily': 1, 'weekly': 0, 'monthly': 0},
                'month' : {'daily': 1, 'weekly': 0, 'monthly': 0},
                'months': {'daily': 0, 'weekly': 1, 'monthly': 0},
                'year'  : {'daily': 0, 'weekly': 0, 'monthly': 1},
            }
        }
    },

    mounted() {
        $('#musicplayer').after( $("#"+ this.oid) );
        this.changeTab('youtube');
        this.getAvailableCountries();

        this.$on('evolution-update', (media, datasets, views_sum) => {
            this.views[media].total = views_sum ? views_sum : this.views[media].total;
            this.views[media].partial = datasets.length ? eval(datasets.join("+")) : 0;
            this.views[media].show = this.period != 'year' || this.countrySelected.code ? this.views[media].partial : this.views[media].total;

            // evolution?
            if (datasets && datasets.length > 1){
                var thisTick = datasets[datasets.length - 1];
                var lastTick = datasets[datasets.length - 2];

                this.views[media].yesterday = thisTick;
                this.views[media].evolution = lastTick ? (thisTick - lastTick) / lastTick * 100 : 0;
            }else{
                this.views[media].yesterday = -9999;
                this.views[media].evolution = -9999;
            }
        });

        this.$root.$on('country-click', (name) => {
            if (this.countrySelected.name.toLowerCase() == name.toLowerCase()){
                this.countrySelected = { name: 'Worldwide', code: 0 };
                return;
            }

            $.each(this.countries, (i,c) => {
                if (c.name.toLowerCase() == name.toLowerCase()){
                    this.countrySelected = c;
                }
            })
        });        
    },
 
    methods: {
        formatToNumber(value) {
            if (value == -9999){ return "Ø"; }

            if (value > 1000000000) return (value/1000000000).toFixed(1) +"<small>B</small>";
            if (value > 1000000) return (value/1000000).toFixed(1) +"<small>M</small>";
            if (value > 1000) return (value/1000).toFixed(1) +"<small>K</small>";
            if (value >= 0) return +value.toFixed(0);
            return "Ø";
        },

        formatToProcent(value){
            return value == -9999 ? "Ø" : value.toFixed(1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") + `%`;
        },

        getAvailableCountries(){
            var countries = App.filters.raw.countries.sort((a, b) => {
                var aName = a.name.toLowerCase();
                var bName = b.name.toLowerCase(); 
                return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
            });

            $.each(countries, (i, c) => {
                this.countries.push({name: c.name, code: c.id});
            });
        },

        evaluateFilters(){
            if ( !this.validStates[this.period][this.filter] ){
                $.each(this.validStates[this.period], (filter, enabled) => {
                    if (enabled){
                        this.filter = filter;
                        return false;
                    }
                });
            }
        },

        changeTab(tab){
            this.activeTab = tab;

            if (App.allowGtag) gtag('config', 'UA-152097964-2', {
                'page_path' : (this.isOwner ? '/mystuff/' : '/profile/') + tab,
                'page_location': (this.isOwner ? '/mystuff/' : '/profile/') + tab,
                'page_title' : (this.isOwner ? 'My stuff' : 'Profile') +" > "+ this.getName(tab),
            });
        },

        changeCountry(country){
            this.countrySelected = country; 
            this.showCountrySelector = false;
        },

        changePeriod(direction){
            if (direction == 1){
                if (this.period == 'year' && !this.overallStats){
                    this.overallStats = true;
                } 
                // else if (this.period == 'months') this.period = 'year';
                else if (this.period == 'month') { this.period = 'year'; this.overallStats = true; }
                else if (this.period == 'week') this.period = 'month';
                else if (this.period == 'day') this.period = 'week';
            }

            if (direction == -1){
                if (this.period == 'year' && this.overallStats){
                    this.period = 'month';
                    this.overallStats = false;
                }else if (this.period == 'year' && !this.overallStats){
                    this.period = 'month';
                    this.overallStats = false;
                } 
                
                else if (this.period == 'week') this.period = 'day';
                else if (this.period == 'month') this.period = 'week';
                // else if (this.period == 'months') this.period = 'month';
                // else if (this.period == 'year') this.period = 'months';
            }

            this.evaluateFilters();
        },
 
        getPeriod(){
            switch (this.period){
                case 'year':   return this.overallStats ? 'All Time' : 'Last Year'; break;
                case 'months': return 'Last 3 Months'; break;
                case 'month':  return 'Last Month'; break;
                case 'week':   return 'Last Week'; break;
                case 'day':   return 'Last 24h'; break;
            }
        },

        getFilter(){
            switch (this.filter){
                case 'monthly':   return 'Monthly'; break;
                case 'weekly': return 'Weekly'; break;
                case 'daily':  return 'Daily'; break;
            }
        },

        getName(provider){
            switch (provider){
                case 'total_streams': return 'All Channels';
                case 'spotify_plays': return 'Spotify'; break;
                case 'spotify_playlists': return 'Spotify Playlists'; break;
                case 'warm_music': return 'Radio'; break;
                case 'apple_music': return 'Apple Music'; break;
                default: return provider;
            }  
        },

        getIcon(provider){
            switch (provider){
                case 'total_streams': return '/img/web/song/statistics/total_streams.png'; break;
                case 'spotify_plays': return '/img/web/song/statistics/spotify.svg'; break;
                case 'spotify_playlists': return '/img/web/song/statistics/spotify.svg'; break;
                default: return `/img/web/song/statistics/${provider}.svg`;
            }            
        },

        isOwner(){
            return this.user.id == App.user.id;
        }
    },

    watch: {
        activeTab(){
            this.$nextTick(() => {
                var scrollLeft = $('#page-profile #statistics-tab .tabs .tab.active').position().left + $('#page-profile #statistics-tab .tabs').scrollLeft() - 30;
                $('#page-profile #statistics-tab .tabs').animate({ scrollLeft: scrollLeft }, 500);

                $('.item-container').scrollLeft(0);
                $('main').animate({ scrollTop: 812 - $('main')[0].scrollHeight }, 500);
            });
        },
 
        overallStats(){
            $.each(this.views, (media, v) => {
                this.views[media].show = this.overallStats ? this.views[media].total : this.views[media].partial;
            })
        },

        showCountrySelector(){
            this.search = '';
            if (this.showCountrySelector == false){
                $('.page-content').addClass('hasFooter');
                this.$root.$emit('unlockScroll');
            }else{
                $('.page-content').removeClass('hasFooter');
                this.$root.$emit('lockScroll');
            }
        },

        search(){
            var qString = this.search;
            $('.page-overlay.country-selector .list li').each((i,e) => {
                if ($(e).text().toLowerCase().indexOf( qString.toLowerCase() ) == -1 && qString.length){
                    $(e).hide();
                }else{
                   $(e).show();
                }
            })
        }
    },

    beforeDestroy() {
        $(`#${this.oid}`).remove();
    }    
}
</script>
